import { render, staticRenderFns } from "./ListAvatar.vue?vue&type=template&id=1d66261e&scoped=true"
import script from "./ListAvatar.vue?vue&type=script&lang=js"
export * from "./ListAvatar.vue?vue&type=script&lang=js"
import style0 from "./ListAvatar.vue?vue&type=style&index=0&id=1d66261e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_3gvhbgb4yg4a32yudvtfqrrcqq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d66261e",
  null
  
)

export default component.exports